import {  } from 'firebase/auth';
import { createApi } from '@reduxjs/toolkit/query/react';
import { fetchBaseQuery } from '@reduxjs/toolkit/query';
import {auth} from "@/features/auth/firebase.js";


function fetchBase() {
  return fetchBaseQuery({
    baseUrl: import.meta.env.VITE_BACKEND_BASE_URL,
    prepareHeaders: async (headers) => {
      const user = auth.currentUser;
      if (user == null) {
        return headers;
      }
      const token = await user.getIdToken();
      if (token) {
        headers.set('X-Firebase-Access-Token', token);
      }
      return headers;
    }
  });
}

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: fetchBase(),
  endpoints: () => ({}),
});

export function extendCrudApi({ entityNameSingular, entityNamePlural, entityPath, extraEndpoints, extraTags }) {
  if (!extraEndpoints) {
    extraEndpoints = () => ({});
  }

  if (!extraTags) {
    extraTags = [];
  }

  const apiWithTag = baseApi.enhanceEndpoints({addTagTypes: [entityNamePlural, ...extraTags]})
  return apiWithTag.injectEndpoints({
    endpoints: (builder) => ({
      [`get${entityNamePlural}`]: builder.query({
        query: (filterBy = {}) => ({
          url: `/${entityPath}/`,
          method: 'GET',
          params: filterBy,
        }),
        providesTags: (result) => result ? [
          ...result.data.map(({ id }) => ({ type: entityNamePlural, id })),
          { type: entityNamePlural, id: 'LIST' }
        ] : [{ type: entityNamePlural, id: 'LIST' }],
      }),
      [`get${entityNameSingular}`]: builder.query({
        query: ({ id }) => ({
          url: `/${entityPath}/${id}`,
          method: 'GET',
        }),
        providesTags: (result, error, arg) => [{ type: entityNamePlural, id: arg.id }],
      }),
      [`update${entityNameSingular}`]: builder.mutation({
        query: ({ id, data }) => ({
          url: `/${entityPath}/${id}`,
          method: 'PUT',
          body: data,
        }),
        invalidatesTags: (result, error, arg) => [{ type: entityNamePlural, id: arg.id }],
      }),
      [`patch${entityNameSingular}`]: builder.mutation({
        query: ({ id, data }) => ({
          url: `/${entityPath}/${id}`,
          method: 'PATCH',
          body: data,
        }),
        invalidatesTags: (result, error, arg) => [{ type: entityNamePlural, id: arg.id }],
      }),
      [`delete${entityNameSingular}`]: builder.mutation({
        query: ({ id }) => ({
          url: `/${entityPath}/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: (result, error, arg) => [
          { type: entityNamePlural, id: arg.id },
          { type: entityNamePlural, id: 'LIST' }
        ],
      }),
      [`create${entityNameSingular}`]: builder.mutation({
        query: ({ data }) => ({
          url: `/${entityPath}/`,
          method: 'POST',
          body: data,
        }),
        invalidatesTags: () => [{ type: entityNamePlural, id: 'LIST' }],
      }),
      ...extraEndpoints(builder),

    }),
    overrideExisting: false,
  });
}

export function extendCrudApiByHousehold({ entityNameSingular, entityNamePlural, entityPath, extraEndpoints, extraTags }) {
  if (!extraEndpoints) {
    extraEndpoints = () => ({});
  }

  if (!extraTags) {
    extraTags = [];
  }

  const apiWithTag = baseApi.enhanceEndpoints({addTagTypes: [entityNamePlural, ...extraTags]})
  return apiWithTag.injectEndpoints({
    endpoints: (builder) => ({
      [`get${entityNamePlural}`]: builder.query({
        query: ({ householdId, ...filterBy }) => ({
          url: `/h/${householdId}/${entityPath}/`,
          method: 'GET',
          params: filterBy,
        }),
        providesTags: (result, error, arg) => result ? [
          ...result.data.map(({ id }) => ({ type: entityNamePlural, id, householdId: arg.householdId })),
          { type: entityNamePlural, id: 'LIST', householdId: arg.householdId }
        ] : [{ type: entityNamePlural, id: 'LIST', householdId: arg.householdId }],
      }),
      [`get${entityNameSingular}`]: builder.query({
        query: ({ householdId, id }) => ({
          url: `/h/${householdId}/${entityPath}/${id}`,
          method: 'GET',
        }),
        providesTags: (result, error, arg) => [{ type: entityNamePlural, id: arg.id, householdId: arg.householdId }],
      }),
      [`update${entityNameSingular}`]: builder.mutation({
        query: ({ householdId, id, data }) => ({
          url: `/h/${householdId}/${entityPath}/${id}`,
          method: 'PUT',
          body: data,
        }),
        invalidatesTags: (result, error, arg) => [{ type: entityNamePlural, id: arg.id, householdId: arg.householdId }],
      }),
      [`patch${entityNameSingular}`]: builder.mutation({
        query: ({ householdId, id, data }) => ({
          url: `/h/${householdId}/${entityPath}/${id}`,
          method: 'PATCH',
          body: data,
        }),
        invalidatesTags: (result, error, arg) => [{ type: entityNamePlural, id: arg.id, householdId: arg.householdId }],
      }),
      [`delete${entityNameSingular}`]: builder.mutation({
        query: ({ householdId, id }) => ({
          url: `/h/${householdId}/${entityPath}/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: (result, error, arg) => [
          { type: entityNamePlural, id: arg.id, householdId: arg.householdId },
          { type: entityNamePlural, id: 'LIST', householdId: arg.householdId }
        ],
      }),
      [`create${entityNameSingular}`]: builder.mutation({
        query: ({ householdId, data }) => ({
          url: `/h/${householdId}/${entityPath}/`,
          method: 'POST',
          body: data,
        }),
        invalidatesTags: (result, error, arg) => [{ type: entityNamePlural, id: 'LIST', householdId: arg.householdId }],
      }),
      ...extraEndpoints(builder),

    }),
    overrideExisting: false,
  });
}
